import { render, staticRenderFns } from "./ObitDetails.vue?vue&type=template&id=11b3436c&scoped=true"
import script from "./ObitDetails.vue?vue&type=script&lang=js"
export * from "./ObitDetails.vue?vue&type=script&lang=js"
import style0 from "./ObitDetails.vue?vue&type=style&index=0&id=11b3436c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b3436c",
  null
  
)

export default component.exports